// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Transfer_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transfer = void 0;
const transaction_1 = require("./transaction");
const ledger_1 = require("../../ledger");
const assets_1 = require("../../ledger/assets");
const typedjson_1 = require("../../export/typedjson");
const transferTypeName = "Transfer";
let Transfer = Transfer_1 = class Transfer extends transaction_1.Transaction {
    constructor(sender, nonce, recipient, values) {
        super(sender, nonce);
        this.recipient = recipient;
        this.values = values;
    }
    txType() {
        return Transfer_1;
    }
    txTypeName() {
        return transferTypeName;
    }
    encodeABI(e, _) {
        e.encode(this.recipient, this.values);
        return "ErdstallTransaction";
    }
};
__decorate([
    typedjson_1.jsonMember(ledger_1.Address),
    __metadata("design:type", ledger_1.Address)
], Transfer.prototype, "recipient", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets_1.Assets),
    __metadata("design:type", assets_1.Assets)
], Transfer.prototype, "values", void 0);
Transfer = Transfer_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [ledger_1.Address, typeof BigInt === "function" ? BigInt : Object, ledger_1.Address,
        assets_1.Assets])
], Transfer);
exports.Transfer = Transfer;
transaction_1.registerTransactionType(transferTypeName, Transfer);
//# sourceMappingURL=transfer.js.map